export enum OnboardingStatus {
  passwordNotChanged = 'password_not_changed',
  pending = 'pending',
  inProgress = 'in_progress',
  underReview = 'under_review',
  completed = 'completed'
}
